// extracted by mini-css-extract-plugin
var _1 = "Card_attachment__KnwuL";
var _2 = "Card_attachmentLeft__jEyOp";
var _3 = "Card_attachments__-CgZV";
var _4 = "Card_attachmentsRight__Jazpc";
var _5 = "Card_body__RHED-";
var _6 = "Card_card__zQfcO";
var _7 = "Card_cardCompleted__EU47Y";
var _8 = "Card_cardDragging__SCHWz";
var _9 = "Card_cardOpen__zS98C";
var _a = "Card_completedIcon__Q34D3";
var _b = "Card_content__ASKh8";
var _c = "Card_cover__Ss36Q";
var _d = "Card_coverFrame__IUsmz";
var _e = "Card_details__wrmtl";
var _f = "Card_detailsIcon__wCvfX";
var _10 = "Card_detailsTitle__IsX6U";
var _11 = "Card_editCardButton__0U0o1";
var _12 = "Card_footer__d0BFV";
var _13 = "Card_labels__qJe5L";
var _14 = "Card_metaChip__BR1PP";
var _15 = "Card_metaCount__aQlkL";
var _16 = "Card_moreUsers__-BQQr";
var _17 = "Card_name__vpWb5";
var _18 = "Card_nameCompleted__LGdkc";
var _19 = "Card_notification__eR7Sh";
var _1a = "Card_notificationFull__JcBBl";
var _1b = "Card_popupWrapper__3a-YJ";
var _1c = "Card_popupWrapper2__pqt-t";
var _1d = "Card_user__MeExM";
var _1e = "Card_users__lqZz3";
var _1f = "Card_wrapper__kLQpI";
export { _1 as "attachment", _2 as "attachmentLeft", _3 as "attachments", _4 as "attachmentsRight", _5 as "body", _6 as "card", _7 as "cardCompleted", _8 as "cardDragging", _9 as "cardOpen", _a as "completedIcon", _b as "content", _c as "cover", _d as "coverFrame", _e as "details", _f as "detailsIcon", _10 as "detailsTitle", _11 as "editCardButton", _12 as "footer", _13 as "labels", _14 as "metaChip", _15 as "metaCount", _16 as "moreUsers", _17 as "name", _18 as "nameCompleted", _19 as "notification", _1a as "notificationFull", _1b as "popupWrapper", _1c as "popupWrapper2", _1d as "user", _1e as "users", _1f as "wrapper" }
